import React, { useState, useEffect, useCallback } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Badge, Box, IconButton, useMediaQuery } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { PickersDay } from '@mui/x-date-pickers';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { CURRENT_DATE } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
// import { format } from 'date-fns';

// import * as actionTypes from 'store/actions';

const events = [new Date('2024-01-01'), new Date('2024-01-02')];

const ServerDay = React.memo(({ highlightedDays = [], day, outsideCurrentMonth, ...other }) => {
  const isSelected = !outsideCurrentMonth && highlightedDays.includes(day.getDate());
  console.log('Day Selected:', day.toString(), 'Is Selected:', isSelected);

  return (
    <Badge
      key={day.toString()}
      overlap="circular"
      sx={isSelected ? { margin: '2px', borderRadius: '50%' } : undefined}
      badgeContent={isSelected ? '' : undefined}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      variant="dot"
      color={isSelected ? 'primary' : undefined}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
    </Badge>
  );
});

const DatePickerStore = () => {
  const date = useSelector((state) => state.customization.currentDate);
  const [calendar, setCalendar] = useState(new Date(date));
  const [highlightedDays, setHighlightedDays] = useState([]);
  const [open, setOpen] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const dispatch = useDispatch();

  const updateHighlightedDays = useCallback((date) => {
    const daysToHighlight = events
      .filter((event) => event.getMonth() === date.getMonth() && event.getFullYear() === date.getFullYear())
      .map((event) => event.getDate());

    setHighlightedDays(daysToHighlight);
  }, []);

  useEffect(() => {
    updateHighlightedDays(calendar);
  }, [calendar, updateHighlightedDays]);

  const handleCalendarToggle = () => {
    setOpen(!open);
  };

  const handleDateChange = (newValue) => {
    if (newValue) {
      console.log('New Date Selected:', newValue);
      setCalendar(newValue);
      updateHighlightedDays(newValue);
      dispatch({ type: CURRENT_DATE, currentDate: newValue });
    }
  };
  // const date = useSelector((state) => state.customization.currentDate);
  console.log('calender data is', date);
  return (
    <div className="flex items-center justify-end gap-2 w-full">
      {isSmallScreen ? (
        <>
          {/* Calendar Icon for Small Screens */}
          <IconButton onClick={handleCalendarToggle}>
            <CalendarTodayIcon sx={{ fontSize: '1.5rem', color: 'black' }} />
          </IconButton>

          {/* Calendar Modal */}
          {open && (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                open={open}
                onClose={() => setOpen(false)}
                value={calendar}
                onChange={handleDateChange}
                slots={{ day: ServerDay }}
                slotProps={{
                  day: { highlightedDays }
                }}
                format="dd/MM/yyyy"
                disableTextInput
              />
            </LocalizationProvider>
          )}
        </>
      ) : (
        // Full DatePicker for Larger Screens
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <DatePicker
              value={calendar}
              onChange={handleDateChange}
              format="dd/MM/yyyy"
              slots={{ day: ServerDay }}
              slotProps={{
                day: { highlightedDays }
              }}
            />
          </Box>
        </LocalizationProvider>
      )}
    </div>
  );
};

export default DatePickerStore;
